import store from '../store/index'
//-------------------
// get race defaults
//-------------------
export default function getRaceDefaults(race_name) {
  console.log('-------------------------------')
  console.log('IN getRaceDefaults race_name = ' + race_name)
  // -------------------------
  // get default race details
  // -------------------------
  let race = store.getters['races/getRaceByName'](race_name)

  if (!race) {
    console.error('ERROR: getRaceDefaults: race not found for race_name = ' + race_name)
    return {}
  }
  //--------------------------
  // get race characteristics
  //--------------------------
  let race_chars = store.getters['races/getRaceCharacteristics'](race.id)
  let race_str = race_chars.find((c) => c.name == 'str')
  let race_con = race_chars.find((c) => c.name == 'con')
  let race_dex = race_chars.find((c) => c.name == 'dex')
  let race_siz = race_chars.find((c) => c.name == 'siz')
  let race_int = race_chars.find((c) => c.name == 'int')
  let race_pow = race_chars.find((c) => c.name == 'pow')
  let race_cha = race_chars.find((c) => c.name == 'cha')
  // ----------------------
  // define chars structure
  // ----------------------
  let defaults = {
    //
    move: race.move,
    move_fly: race.move_fly,
    //
    str_rolled: race_str.value,
    str_min: race_str.min,
    str_max: race_str.max,
    str_improvs_tot: 0,
    //
    con_rolled: race_con.value,
    con_min: race_con.min,
    con_max: race_con.max,
    con_improvs_tot: 0,
    //
    dex_rolled: race_dex.value,
    dex_min: race_dex.min,
    dex_max: race_dex.max,
    dex_improvs_tot: 0,
    //
    siz_rolled: race_siz.value,
    siz_min: race_siz.min,
    siz_max: race_siz.max,
    siz_improvs_tot: 0,
    //
    int_rolled: race_int.value,
    int_min: race_int.min,
    int_max: race_int.max,
    int_improvs_tot: 0,
    //
    pow_rolled: race_pow.value,
    pow_min: race_pow.min,
    pow_max: race_pow.max,
    pow_improvs_tot: 0,
    //
    cha_rolled: race_cha.value,
    cha_min: race_cha.min,
    cha_max: race_cha.max,
    cha_improvs_tot: 0,
    //
    combat_inclusion: false,
    second_weapon: false,
    shield: false,
    ranged: false,
    magic: false,
    special_action: race.special_action,
    special_reaction: race.special_action,
    //
    trait_name: race.trait_name,
  }
  return defaults
}
